import { Indicator } from '../../../Common/Charts/Indicator';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';

export const WeightLessThan25kg = () => {
    const { chartData } = useIdentificationChartsDataContext();

    return (
        <Indicator
            title={'Indice de Peso (menor que 2,5kg)'}
            indicatorValue={chartData?.indicators?.weightLessThan25kg}
            className='aligned-container'
        />
    );
};
